import gql from "graphql-tag";
import {useMemo} from "react";

import type {Result} from "@khanacademy/wonder-blocks-data";
import {useQuery} from "@khan/data-gql";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {aiGuideSwagAppliedQueryType} from "./__graphql-types__/index.ts";

const AI_GUIDE_SWAG_APPLIED_QUERY: GqlOperation<
    aiGuideSwagAppliedQueryType["response"],
    aiGuideSwagAppliedQueryType["variables"]
> = gqlOp(gql`
    query aiGuideSwagAppliedQuery {
        user {
            id
            aiGuideSwagApplied {
                id
            }
        }
    }
`);

export const useGuideSwagApplied = (): Result<string> => {
    const [result] = useQuery(AI_GUIDE_SWAG_APPLIED_QUERY);

    return useMemo(() => {
        if (result.status !== "success") {
            return result;
        }

        return {
            status: "success",
            data: result.data.user?.aiGuideSwagApplied?.id ?? "default",
        };
    }, [result]);
};
